import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const Hero2SectionImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: '2_1_568', width: 720, height: 360, ratio: 2 },
  { screen: Screen.SM, key: '3_2_512', width: 568, height: 379, ratio: 1.5 },
  { screen: Screen.MD, key: '3_2_683', width: 720, height: 480, ratio: 1.5 },
  { screen: Screen.LG, key: '3_2_788', width: 960, height: 640, ratio: 1.5 },
  { screen: Screen.XL, key: '3_2_1024', width: 1024, height: 683, ratio: 1.5 },
];
